import moment from 'moment'
import 'moment-timezone'

export const getMomentTz = (date, format = null) => {
  if (format) {
    return moment(date, format).tz('Europe/Amsterdam')
  }
  return moment(date).tz('Europe/Amsterdam')
}
